import { render, staticRenderFns } from "./CardTotalCost.vue?vue&type=template&id=05a01e35"
import script from "./CardTotalCost.vue?vue&type=script&lang=js"
export * from "./CardTotalCost.vue?vue&type=script&lang=js"
import style0 from "./CardTotalCost.vue?vue&type=style&index=0&id=05a01e35&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports